import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    ctaLabel: 'Invite again',
    description:
      'You would like to add an additional access to your account. This access is not inclued in your plan and will therefore be charged.',
    errors: {
      invitationError:
        'Due to a technical issue, we were unable to send the invite. Please try again and do not hesitate to contact us if the problem persists.',
    },
    success: '{firstName} {lastName} has been successfully unlocked',
    title: 'Review information',
  },
  fr: {
    cancel: 'Annuler',
    ctaLabel: 'Inviter à nouveau',
    description:
      'Vous souhaitez ajouter un accès supplémentaire à votre compte. Celui-ci n’est pas inclus dans votre offre et sera donc facturé.',
    errors: {
      invitationError:
        'Suite à une erreur technique, nous n’avons pas pu restaurer l’accès. Veuillez réessayer et n’hésitez pas à nous contacter si le problème persiste.',
    },
    success: 'Les accès de {firstName} {lastName} ont bien été restaurés',
    title: 'Vérifiez les informations',
  },
});

export default locales;
